import {ReactComponent as DirectionalLight} from "assets/image/Layout/ObjectPanel/Layer/ic_directional_light.svg";
import {ReactComponent as HemisphereLight} from "assets/image/Layout/ObjectPanel/Layer/ic_hemisphere_light.svg";
import {ReactComponent as PointLight} from "assets/image/Layout/ObjectPanel/Layer/ic_point_light.svg";
import {ReactComponent as SpotLight} from "assets/image/Layout/ObjectPanel/Layer/ic_spot_light.svg";
import {ReactComponent as AmbientLight} from "assets/image/Layout/ObjectPanel/Layer/ic_ambient_light.svg";
import {ReactComponent as Box} from "assets/image/Layout/ObjectPanel/Layer/ic_box.svg";
import {ReactComponent as Cylinder} from "assets/image/Layout/ObjectPanel/Layer/ic_cylinder.svg";
import {ReactComponent as Capsule} from "assets/image/Layout/ObjectPanel/Layer/ic_capsule.svg";
import {ReactComponent as Tetrahedron} from "assets/image/Layout/ObjectPanel/Layer/ic_tetrahedron.svg";
import {ReactComponent as Sphere} from "assets/image/Layout/ObjectPanel/Layer/ic_sphere.svg";
import {ReactComponent as Icosahedron} from "assets/image/Layout/ObjectPanel/Layer/ic_icosahedron.svg";
import {ReactComponent as Circle} from "assets/image/Layout/ObjectPanel/Layer/ic_circle.svg";
import {ReactComponent as Ring} from "assets/image/Layout/ObjectPanel/Layer/ic_ring.svg";
import {ReactComponent as Dodecahedron} from "assets/image/Layout/ObjectPanel/Layer/ic_dodecahedron.svg";
import {ReactComponent as Torus} from "assets/image/Layout/ObjectPanel/Layer/ic_torus.svg";
import {ReactComponent as TorusKnot} from "assets/image/Layout/ObjectPanel/Layer/ic_torus_knot.svg";
import {ReactComponent as Tube} from "assets/image/Layout/ObjectPanel/Layer/ic_tube.svg";
import {ReactComponent as Plane} from "assets/image/Layout/ObjectPanel/Layer/ic_plane.svg";
import {ReactComponent as Octahedron} from "assets/image/Layout/ObjectPanel/Layer/ic_octahedron.svg";
import {ReactComponent as Lathe} from "assets/image/Layout/ObjectPanel/Layer/ic_lathe.svg";
import {ReactComponent as PerspectiveCamera} from "assets/image/Layout/ObjectPanel/Layer/ic_perspective_camera.svg";
import {ReactComponent as OrthographicCamera} from "assets/image/Layout/ObjectPanel/Layer/ic_orthographic_camera.svg";
import {ReactComponent as Sound} from "assets/image/Layout/ObjectPanel/Layer/ic_sound.svg";
import {ReactComponent as Startpoint} from "assets/image/Layout/ObjectPanel/Layer/ic_startpoint.svg";
import {ReactComponent as Ground} from "assets/image/Layout/ObjectPanel/Layer/ic_ground.svg";
import {ReactComponent as ObjectDefault} from "assets/image/Layout/ObjectPanel/Layer/ic_object_default.svg";
import {ReactComponent as World} from "assets/image/Layout/ObjectPanel/Layer/ic_world.svg";
import {MESH} from "utils/constants";

const lightIcons = {
  DirectionalLight: <DirectionalLight />,
  HemisphereLight: <HemisphereLight />,
  PointLight: <PointLight />,
  SpotLight: <SpotLight />,
  AmbientLight: <AmbientLight />,
};

const meshIcons = {
  [MESH.BOX]: <Box />,
  [MESH.CYLINDER]: <Cylinder />,
  [MESH.CAPSULE]: <Capsule />,
  [MESH.TETRAHEDRON]: <Tetrahedron />,
  [MESH.SPHERE]: <Sphere />,
  [MESH.ICOSAHEDRON]: <Icosahedron />,
  [MESH.CIRCLE]: <Circle />,
  [MESH.RING]: <Ring />,
  [MESH.DODECAHEDRON]: <Dodecahedron />,
  [MESH.TORUS]: <Torus />,
  [MESH.TORUSKNOT]: <TorusKnot />,
  [MESH.TUBE]: <Tube />,
  [MESH.PLANE]: <Plane />,
  [MESH.OCTAHEDRON]: <Octahedron />,
  [MESH.LATHE]: <Lathe />,
};

const cameraIcons = {
  PerspectiveCamera: <PerspectiveCamera />,
  OrthographicCamera: <OrthographicCamera />,
};

const objectIcons = {
  ...lightIcons,
  ...meshIcons,
  ...cameraIcons,
  Sound: <Sound />,
  Startpoint: <Startpoint />,
  Ground: <Ground />,
  ObjectDefault: <ObjectDefault />,
  World: <World />,
};

const ObjectIcon = ({type, name, userData}) => {
  let icon;
  if (type === "Scene") icon = objectIcons["World"];
  else if (name === "ground") icon = objectIcons["Ground"];
  else if (name === "StartLocation") icon = objectIcons["Startpoint"];
  else if (type === "Mesh") icon = objectIcons[name];
  else if (type.endsWith("Light")) icon = objectIcons[type];
  else if (type.endsWith("Camera")) icon = objectIcons[type];
  else if (userData.type === "audio") icon = objectIcons["Sound"];
  return icon || objectIcons["ObjectDefault"];
};

export {objectIcons, ObjectIcon};
